import React from 'react';
import { observer } from "mobx-react-lite";
import { ItemSelectionMode } from '../../../../../shared/action/ActionModel';
import { useTranslation } from 'react-i18next';
import { ActionEditorChangeGroup, groupUndoableActionEditorChanges } from '../../../../stores/undo/operation/ActionEditorSubmitChangesOp';
import { ItemSelector } from '../../selector/ItemSelector';
import { formatTreeParameter } from "../../../../../shared/helper/actionTreeHelper";
import { Dropdown } from "../../../editor/Dropdown";
import { Input } from "../../../editor/Input";
import { isBlank } from "../../../../../shared/helper/generalHelpers";
import { gameStore } from '../../../../stores/GameStore';
import { itemStore } from '../../../../stores/ItemStore';
import { ElementGroup, ElementLabel } from './BaseElements';
export const ItemSelectionActionDetail = observer(({
  parentTree,
  name,
  itemIdOrTags,
  itemIdOrTagsSetter,
  selectionMode,
  selectionModeSetter,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  const {
    languageKey
  } = gameStore;
  const useTags = selectionMode !== ItemSelectionMode.Item;
  const multipleTags = useTags && selectionMode !== ItemSelectionMode.ItemWithOneTag;
  const itemIdsOrTags = useTags ? itemStore.getAllItemTags() : itemStore.getAllItems.map(i => i.id);
  const itemNamesOrTags = useTags ? itemStore.getAllItemTags() : itemStore.getAllItems.map(i => i.name.get(languageKey));
  const parameters = parentTree.treeParameterActions(useTags ? "actions/ItemTagValueModel" : "actions/ItemIdValueModel").map(a => formatTreeParameter(a.name));
  const allItemIdsOrTags = ["", ...parameters, ...itemIdsOrTags];
  const allItemOrTagsLiterals = ["", ...parameters, ...itemNamesOrTags];

  const changeSelectionMode = newMode => {
    groupUndoableActionEditorChanges(ActionEditorChangeGroup.UnspecificGroupedNodeChanges, () => {
      if (newMode === ItemSelectionMode.Item || newMode === ItemSelectionMode.ItemWithOneTag) {
        // reset when changing to a 'single thing' drop-down selection
        itemIdOrTagsSetter("");
      }

      selectionModeSetter(newMode);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, selectionModeSetter && /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(Dropdown, {
    value: selectionMode,
    onChange: ({
      target
    }) => changeSelectionMode(parseInt(target.value))
  }, Object.keys(ItemSelectionMode).filter(value => !Number.isNaN(Number(value))).map(mode => /*#__PURE__*/React.createElement("option", {
    key: mode,
    value: mode
  }, t("content.item_selection_mode_" + ItemSelectionMode[mode]))))), name && /*#__PURE__*/React.createElement(ElementLabel, null, name), !multipleTags && !useTags && /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ItemSelector, {
    value: itemIdOrTags,
    valueSetter: itemIdOrTagsSetter,
    treeParameters: parameters,
    allowBlankValue: allowBlankValue
  })), !multipleTags && useTags && /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: !allowBlankValue && isBlank(itemIdOrTags) ? "invalid" : "",
    value: itemIdOrTags,
    onChange: ({
      target
    }) => itemIdOrTagsSetter(target.value)
  }, allItemIdsOrTags.map((itemId, index) => /*#__PURE__*/React.createElement("option", {
    key: itemId,
    value: itemId
  }, allItemOrTagsLiterals[index])))), multipleTags && /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(Input, {
    className: !allowBlankValue && isBlank(itemIdOrTags) ? "invalid" : "",
    type: "text",
    value: itemIdOrTags,
    onChange: ({
      target
    }) => itemIdOrTagsSetter(target.value)
  })));
});